<div *ngIf="isLoading" class="loading">
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</div>
<ngx-json-viewer class="json-viewer" [json]="careplanTemplate" [expanded]="false" *ngIf="!isLoading"></ngx-json-viewer>
